import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';
import changeTrackable, { IChangeTrackable } from './changeTrackable';

export interface IJobCostStat extends IModel, IChangeTrackable {
	workAreaKey?: string;
	group?: number;
	name?: string;
	value?: string;
	sortIndex?: number;
}

const jobCostStatFactory = modelFactory.createFactory<IJobCostStat>('JobCostStat', _.assign({}, model, changeTrackable, {
	workAreaKey: {
	},
	group: {
		rules: validator.enum('jobCostStatGroups') // allow 0
	},
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	sortIndex: {
		setFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	}
}));

export default jobCostStatFactory;